// extracted by mini-css-extract-plugin
export default {"scroller":"scrollBox__scroller__TDIDo","mobile":"scrollBox__mobile__SmKrg","dirX":"scrollBox__dirX__YP0BF","dirY":"scrollBox__dirY__Xj8Lu","hideBar":"scrollBox__hideBar__Aqd9y"};